import { VendorHandler } from '@portal/app/dashboard/integrations/shared/vendor-handlers/vendor-handler';
import { map } from 'lodash-es';
import {
  IOAuthDetails,
  IVendorConnectConfirmation,
  IVendorConnectInitResponse
} from '@portal/app/dashboard/integrations/models/vendor/VendorIntegrationModels';
import { IVendorInitiateRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorInitiateRequest';
import {
  callbackDomain,
  VendorIdSource
} from '@portal/app/dashboard/integrations/shared/constants';
import { IVendorConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorConfigurationRequest';
import { IVendorOAuthConfirmationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorOAuthConfirmationRequest';
import { IVendorReConfigurationRequest } from '@portal/app/dashboard/integrations/models/vendor/IVendorReConfigurationRequest';
import { StorageService } from '@portal/app/shared/services/storage.service';
import { WindowService } from '@portal/app/shared/services/window.service';

export class SearchAds360Handler implements VendorHandler {
  constructor(
    private storageService: StorageService,
    private windowService: WindowService
  ) {}

  prepareRequestObjectToInitiateVendor(): IVendorInitiateRequest {
    return {
      queryParams: { callbackDomain: callbackDomain() },
      pathParams: { vendorId: VendorIdSource.searchads360 }
    };
  }

  handleVendorInitiateResponse(data: IVendorConnectInitResponse): void {
    localStorage.setItem(
      'callBackParams',
      JSON.stringify(
        (data.vendorCredentialsDetails as IOAuthDetails).callbackParameters
      )
    );
    this.windowService.navigateToHref(
      (data.vendorCredentialsDetails as IOAuthDetails).redirectURL
    );
  }

  confirmVendor(data: IVendorConnectConfirmation): void {
    const jsonData = data.accountDetails
      ? JSON.stringify(data.accountDetails.vendorAccounts)
      : '';
    this.storageService.setIntegrationAccountDetails(
      VendorIdSource.searchads360,
      jsonData
    );
  }

  prepareRequestObjectToConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      clientAccountName?: string;
      managerId?: string;
      timeZone?: string;
      disabled: boolean;
      endpoint?: string;
      credentialId?: number;
    }[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.searchads360,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        clientAccountName: account.clientAccountName || account.accountName,
        managerId: account.managerId || '',
        timeZone: account.timeZone || '',
        endpoint: account.endpoint || ''
      }))
    };
  }

  prepareRequestObjectToReauthorizeVendor(
    accounts: {
      accountName: string;
      accountId: string;
      clientAccountName?: string;
      managerId?: string;
      timeZone?: string;
      disabled: boolean;
      endpoint?: string;
    }[]
  ): IVendorConfigurationRequest {
    return {
      vendorId: VendorIdSource.searchads360,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        clientAccountName: account.clientAccountName || account.accountName,
        managerId: account.managerId || '',
        timeZone: account.timeZone || '',
        endpoint: account.endpoint || ''
      }))
    };
  }

  prepareRequestToConfirmVendor(): IVendorOAuthConfirmationRequest {
    return {
      code: `${localStorage.getItem('code')}`,
      state: `${localStorage.getItem('state')}`,
      callbackDomain: callbackDomain()
    };
  }

  prepareRequestObjectToReConfigureVendor(
    accounts: {
      accountName: string;
      accountId: string;
      managerId?: string | undefined;
      disabled: boolean;
    }[],
    dsInstanceIds: number[]
  ): IVendorReConfigurationRequest {
    return {
      vendorId: VendorIdSource.searchads360,
      vendorData: map(accounts, (account) => ({
        clientAccountId: account.accountId,
        managerId: account.managerId || ''
      })),
      dsInstanceIds
    };
  }
}
